import { ReduceStore } from 'flux/utils';
import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import getCurrentBrand from '../utils/getCurrentBrand';
import feedbackMakeHelpConfiguration from "../utils/feedbackMakeHelpConfiguration";
import feedbackMakeReportProblemConfiguration from "../utils/feedbackMakeReportProblemConfiguration";
import feedbackMakeSuggestionConfiguration from "../utils/feedbackMakeSuggestionConfiguration";

const INITIAL_STATE = {
  isVisible: false,
  name: null,
  properties: {},
};

class ModalFullscreenStore extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return INITIAL_STATE;
  }

  getModalHelpUrl(configuration) {
    return `https://goresponsa.com/integrations/valentino/training_app?hide_question_subject=true&question_subject_value=Help&question_form_subject_position=down&question_form_details_position=down&auto_tag=${getCurrentBrand()}&custom_form=${encodeURIComponent(feedbackMakeHelpConfiguration(configuration))}`;
  }

  getModalReportProblemUserUrl(configuration) {
    return `https://goresponsa.com/integrations/valentino/training_app?hide_question_subject=true&question_subject_value=Report%20a%20problem&question_form_subject_position=down&question_form_details_position=down&auto_tag=${getCurrentBrand()}&custom_form=${encodeURIComponent(feedbackMakeReportProblemConfiguration(configuration))}`;
  }

  getModalReportProblemStoreUrl(configuration) {
    return `https://goresponsa.com/integrations/valentino/training_app?hide_question_subject=true&question_subject_value=Suggestion&question_form_subject_position=down&question_form_details_position=down&auto_tag=${getCurrentBrand()}&custom_form=${encodeURIComponent(feedbackMakeSuggestionConfiguration(configuration))}`;
  }

  reduce(state, action) {
    switch (action.actionType) {
      case ActionTypes.MODAL_FULLSCREEN_MODAL_HELP:
        return {
          isVisible: true,
          name: 'help',
          properties: {
            url: this.getModalHelpUrl(action.predefined)
          },
        };

      case ActionTypes.MODAL_FULLSCREEN_REPORT_PROBLEM_USER:
        return {
          isVisible: true,
          name: 'report_problem',
          properties: {
            url: this.getModalReportProblemUserUrl(action.predefined)
          },
        };

      case ActionTypes.MODAL_FULLSCREEN_REPORT_PROBLEM_STORE:
        return {
          isVisible: true,
          name: 'suggestion',
          properties: {
            url: this.getModalReportProblemStoreUrl(action.predefined)
          },
        };

      case ActionTypes.MODAL_FULLSCREEN_USER:
        return {
          isVisible: true,
          name: 'user',
          properties: action.properties,
        };

      case ActionTypes.MODAL_FULLSCREEN_GLOSSARY:
        return {
          isVisible: true,
          name: 'glossary',
          properties: {
            glossaryFilterIconVisible: true,
            ...action.properties,
          },
        };

      case ActionTypes.MODAL_FULLSCREEN_CLOSE:
        return { ...state, isVisible: false };

      case ActionTypes.MODAL_FULLSCREEN_CLOSED:
        return INITIAL_STATE;

      case ActionTypes.MODAL_FULLSCREEN_CLOSED_CLEAR_ROUTE_URI:
        return {
          ...state,
          properties: {
            ...state.properties,
            routeUri: undefined,
          }
        }

      case ActionTypes.MOBILE_MODAL_SEARCH:
        return {
          isVisible: true,
          name: 'search',
          properties: action.properties,
        };

      case ActionTypes.GLOSSARY_TOGGLE_FILTER_ICON:
        return {
          ...state,
          properties: {
            ...state.properties,
            glossaryFilterIconVisible: action.visible,
          },
        }

      case ActionTypes.MOBILE_MODAL_NEWS:
        return {
          isVisible: true,
          name: 'news',
          properties: action.properties,
        };


      default:
        return state;
    }
  }
}

export default new ModalFullscreenStore();
